"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _plugins = _interopRequireDefault(require("./plugins"));
var _toolbar = _interopRequireDefault(require("./toolbar"));
var _ZBKJIutil = require("@/utils/ZBKJIutil");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default2 = exports.default = {
  name: 'Tinymce',
  props: {
    id: {
      type: String,
      default: function _default() {
        return 'vue-tinymce-' + +new Date() + ((Math.random() * 1000).toFixed(0) + '');
      }
    },
    value: {
      type: String,
      default: ''
    },
    toolbar: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    menubar: {
      type: String,
      default: 'file edit insert view format table'
    },
    height: {
      type: Number,
      required: false,
      default: 400
    }
  },
  data: function data() {
    return {
      hasChange: false,
      hasInit: false,
      tinymceId: this.id,
      fullscreen: false,
      languageTypeList: {
        en: 'en',
        zh: 'zh_CN'
      }
    };
  },
  computed: {
    language: function language() {
      // return this.languageTypeList[this.$product.getters.language]
      return this.languageTypeList['zh'];
    }
  },
  watch: {
    value: function value(val) {
      var _this2 = this;
      if (!this.hasChange && this.hasInit) {
        this.$nextTick(function () {
          return window.tinymce.get(_this2.tinymceId).setContent(val || '');
        });
      }
    },
    language: function language() {
      var _this3 = this;
      this.destroyTinymce();
      this.$nextTick(function () {
        return _this3.initTinymce();
      });
    }
  },
  mounted: function mounted() {
    this.initTinymce();
  },
  activated: function activated() {
    this.initTinymce();
  },
  deactivated: function deactivated() {
    this.destroyTinymce();
  },
  destroyed: function destroyed() {
    this.destroyTinymce();
  },
  methods: {
    initTinymce: function initTinymce() {
      var _this4 = this;
      var _this = this;
      window.tinymce.init({
        language: this.language,
        selector: "#".concat(this.tinymceId),
        height: this.height,
        body_class: 'panel-body ',
        object_resizing: true,
        // 启用图片/表格调整大小
        resize_img_proportional: true,
        // 保持图片比例缩放
        toolbar: this.toolbar.length > 0 ? this.toolbar : _toolbar.default,
        menubar: this.menubar,
        plugins: _plugins.default,
        end_container_on_empty_block: true,
        powerpaste_word_import: 'clean',
        code_dialog_height: 450,
        code_dialog_width: 1000,
        advlist_bullet_styles: 'square',
        advlist_number_styles: 'default',
        imagetools_cors_hosts: ['www.tinymce.com', 'codepen.io'],
        default_link_target: '_blank',
        link_title: false,
        convert_urls: false,
        //防止路径被转化为相对路径
        paste_data_images: true,
        // 默认是false的，记得要改为true才能粘贴
        automatic_uploads: true,
        // 启用拖拽上传
        nonbreaking_force_tab: true,
        // inserting nonbreaking space &nbsp; need Nonbreaking Space Plugin
        init_instance_callback: function init_instance_callback(editor) {
          if (_this.value) {
            editor.setContent(_this.value);
          }
          _this.hasInit = true;
          editor.on('NodeChange Change KeyUp SetContent', function () {
            _this4.hasChange = true;
            // 获取原始HTML并转换为小程序兼容格式
            var rawHtml = editor.getContent();
            var compatibleHtml = _this.convertToMiniProgram(rawHtml);
            _this4.$emit('input', compatibleHtml);
          });
        },
        setup: function setup(editor) {
          editor.addButton('Upload', {
            icon: 'image',
            tooltip: '上传图片',
            onclick: function onclick() {
              _this.modalPicTap(true);
            }
          });
        },
        images_upload_handler: function () {
          var _images_upload_handler = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(blobInfo, succFun, failFun) {
            var file, formData, data, res, _t;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.p = _context.n) {
                case 0:
                  file = blobInfo.blob(); //转化为易于理解的file对象
                  formData = new FormData();
                  data = {
                    model: 'product',
                    pid: 0
                  };
                  formData.append('multipart', file);
                  _context.p = 1;
                  _context.n = 2;
                  return (0, _ZBKJIutil.uploadImage)(formData, data);
                case 2:
                  res = _context.v;
                  succFun(res.url);
                  _context.n = 4;
                  break;
                case 3:
                  _context.p = 3;
                  _t = _context.v;
                case 4:
                  return _context.a(2);
              }
            }, _callee, null, [[1, 3]]);
          }));
          function images_upload_handler(_x, _x2, _x3) {
            return _images_upload_handler.apply(this, arguments);
          }
          return images_upload_handler;
        }()
      });
    },
    modalPicTap: function modalPicTap(multiple) {
      var _this = this;
      this.$modalUpload(function (img) {
        if (!img) return;
        var arr = [];
        if (img.length > 10) return this.$message.warning('最多选择10张图片！');
        img.map(function (item) {
          arr.push(item.sattDir);
        });
        _this.imageSuccessCBK(arr);
      }, multiple, 'content');
    },
    destroyTinymce: function destroyTinymce() {
      var tinymce = window.tinymce.get(this.tinymceId);
      if (this.fullscreen) {
        tinymce.execCommand('mceFullScreen');
      }
      if (tinymce) {
        tinymce.destroy();
      }
    },
    setContent: function setContent(value) {
      window.tinymce.get(this.tinymceId).setContent(value);
    },
    getContent: function getContent() {
      window.tinymce.get(this.tinymceId).getContent();
    },
    convertToMiniProgram: function convertToMiniProgram(html) {
      if (!html) return '';
      var result = html;

      // 1. 移除style和script标签
      result = result.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');
      result = result.replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '');

      // 2. 处理图片 - 只保留src，移除尺寸信息
      result = result.replace(/<img([^>]*?)>/gi, function (match, attrs) {
        var srcMatch = attrs.match(/src=["']([^"']*)["']/i);
        var src = srcMatch ? srcMatch[1] : '';

        // 构建干净的img标签，不保留任何尺寸信息
        var imgTag = "<img src=\"".concat(src, "\">");
        console.log('图片处理:', {
          原始: match,
          提取: {
            src: src
          },
          输出: imgTag
        });
        return src ? imgTag : '';
      });

      // 3. 处理视频 - 保留src和width/height属性
      result = result.replace(/<video([^>]*?)>[\s\S]*?<\/video>/gi, function (match, attrs) {
        var srcMatch = attrs.match(/src=["']([^"']*)["']/i);
        var src = srcMatch ? srcMatch[1] : '';

        // 提取width和height
        var width = '';
        var height = '';
        var styleMatch = attrs.match(/style=["']([^"']*)["']/i);
        if (styleMatch) {
          var styleStr = styleMatch[1];
          var widthMatch = styleStr.match(/width:\s*([^;]+)/i);
          var heightMatch = styleStr.match(/height:\s*([^;]+)/i);
          if (widthMatch) width = widthMatch[1].trim();
          if (heightMatch) height = heightMatch[1].trim();
        }
        var attrWidthMatch = attrs.match(/width=["']?([^"'\s>]+)["']?/i);
        var attrHeightMatch = attrs.match(/height=["']?([^"'\s>]+)["']?/i);
        if (attrWidthMatch) width = attrWidthMatch[1];
        if (attrHeightMatch) height = attrHeightMatch[1];

        // 确保宽高值带有单位，如果没有单位则添加px
        if (width && !/px|%|em|rem|vw|vh/i.test(width)) {
          width = width + 'px';
        }
        if (height && !/px|%|em|rem|vw|vh/i.test(height)) {
          height = height + 'px';
        }

        // 构建干净的video标签，使用style来保存尺寸
        var videoTag = "<video src=\"".concat(src, "\"");
        if (width || height) {
          var _styleStr = '';
          if (width) _styleStr += "width:".concat(width, ";");
          if (height) _styleStr += "height:".concat(height, ";");
          videoTag += " style=\"".concat(_styleStr, "\"");
        }
        videoTag += '></video>';
        console.log('视频处理:', {
          原始: match,
          提取: {
            src: src,
            width: width,
            height: height
          },
          输出: videoTag
        });
        return src ? videoTag : '';
      });

      // 4. 移除非img/video标签的style属性
      result = result.replace(/<(?!img|video)([a-zA-Z][a-zA-Z0-9]*)[^>]*?\s+style=["']([^"']*)["']/gi, function (match) {
        return match.replace(/\s+style=["'][^"']*["']/gi, '');
      });

      // 5. 移除class和data-*属性
      result = result.replace(/\s+class=["'][^"']*["']/gi, '');
      result = result.replace(/\s+data-[a-zA-Z0-9-]*=["'][^"']*["']/gi, '');
      console.log('原始HTML:', html);
      console.log('转换后HTML:', result);
      return result;
    },
    imageSuccessCBK: function imageSuccessCBK(arr) {
      var _this5 = this;
      var _this = this;
      arr.forEach(function (v) {
        if (_this5.getFileType(v) == 'video') {
          window.tinymce.get(_this.tinymceId).insertContent("<video src=\"".concat(v, "\"></video>"));
        } else {
          window.tinymce.get(_this.tinymceId).insertContent("<img src=\"".concat(v, "\" />"));
        }
      });
    },
    getFileType: function getFileType(fileName) {
      // 后缀获取
      var suffix = '';
      // 获取类型结果
      var result = '';
      try {
        var flieArr = fileName.split('.');
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = '';
      }
      // fileName无后缀返回 false
      if (!suffix) {
        return false;
      }
      suffix = suffix.toLocaleLowerCase();
      // 图片格式
      var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
      // 进行图片匹配
      result = imglist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'image';
      }
      // 匹配 视频
      var videolist = ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v'];
      result = videolist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'video';
      }
      // 其他 文件类型
      return 'other';
    }
  }
};